import Pusher from 'pusher-js'

/**
 * The app's single Pusher connection. Kept in its own module so that it
 * survives a hot reload of the layout that opens it: a second connection
 * would deliver every event twice (twice the toasts, twice the requests).
 */
let client = null

/** Opens the connection (closing any previous one) and subscribes to `channelName`. */
export function connectPusher(key, channelName, handlers) {
  disconnectPusher()
  client = new Pusher(key, { cluster: 'eu' })
  const channel = client.subscribe(channelName)
  for (const [event, handler] of Object.entries(handlers)) {
    channel.bind(event, handler)
  }
  return client
}

export function disconnectPusher() {
  if (!client) return
  for (const channel of client.allChannels()) {
    channel.unbind_all()
    client.unsubscribe(channel.name)
  }
  client.disconnect()
  client = null
}
